import { useMutation } from "@tanstack/react-query";
import { RESET_CURRENT_USER } from "../api/queries";
import { graphQLClient } from "../graphqlClient";

// Input params:
// confirmation: String - The confirmation phrase "reset me"
export const useResetCurrentUser = () => {
  const resetUserMutation = async (confirmation) => {
    return graphQLClient.request(RESET_CURRENT_USER, {
      confirmation,
    });
  };

  const mutation = useMutation({
    mutationFn: resetUserMutation,
    onSuccess: () => {
      localStorage.removeItem("REACT_QUERY_OFFLINE_CACHE");
      window.location.reload();
    },
    onError: (error) => {
      console.error("Error resetting user:", error);
      // Potentially show an error message to the user
    },
  });

  return {
    resetUser: mutation.mutateAsync,
    isLoading: mutation.isLoading,
    error: mutation.error,
  };
};
